/**
 * Audit service
 */

import { apiClient } from '../utils/api';
import type { AuditEvent, ApiResponse } from '../../../shared/src/types';

export interface ListAuditEventsFilters {
  entity_type?: string;
  entity_id?: string;
  event_type?: string;
  limit?: number;
  offset?: number;
}

export async function listAuditEvents(filters?: ListAuditEventsFilters): Promise<AuditEvent[]> {
  const queryParams = new URLSearchParams();
  if (filters?.entity_type) queryParams.append('entity_type', filters.entity_type);
  if (filters?.entity_id) queryParams.append('entity_id', filters.entity_id);
  if (filters?.event_type) queryParams.append('event_type', filters.event_type);
  if (filters?.limit) queryParams.append('limit', filters.limit.toString());
  if (filters?.offset) queryParams.append('offset', filters.offset.toString());

  const url = `/audit${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await apiClient.get<ApiResponse<AuditEvent[]>>(url);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching audit events');
  }

  return response.data.data || [];
}

